<template>
  <div class="row">
    <div v-for="(row, i) in summaryData" :key="i" class="col-6 col-lg-3 card-wrap">
      <div class="card card-total">
        <div class="card-body">
          <div class="display-4" v-if='row.isCurrency'>{{ row.blockValue | currency-filter }}</div>
          <div class="display-4" v-else><span>{{ row.blockValue }}</span><span class="ml-1">{{unitData[i].unitLabel}}</span></div>
          <span>{{ row.blockTitle }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '../../../config/admin/filters';

export default {
  props: {
    tableData: {
      columns: [],
      summary: {},
    },
  },
  data() {
    return {
      summaryBlocks: [{ // TODO: Use config values
        blockTitle: 'No Data Received',
        blockValue: '##',
      }],
      unitData: [ // TODO: Use config values
        { unitLabel: 'Quotes' },
        { unitLabel: 'Rate Calls' },
        { unitLabel: 'Policies' },
        { unitLabel: '' },
      ],
    };
  },
  computed: {
    summaryData() {
      if (!this.tableData) {
        return this.summaryBlocks;
      }

      const self = this;
      const summaryBlocks = [];

      Object.keys(self.tableData.columns).forEach((column) => {
        const blockTitle = (self.tableData.columns && self.tableData.columns[column] ? self.tableData.columns[column] : '[Summary Block title needed]');
        const blockValue = (self.tableData.summary && self.tableData.summary[column] ? self.tableData.summary[column] : '0');
        const isCurrency = (filters.columns.currency.indexOf(column) !== -1);

        summaryBlocks.push({ blockTitle, blockValue, isCurrency });
      });

      return summaryBlocks;
    },
  },
};
</script>

<style scoped>
.display-4{
  font-size: 2.5rem;
}
@media (min-width: 992px) and (max-width: 1170px) {
  .display-4{
    font-size: 1.75rem !important;
  }
}

.card-total {
  background-color: #EDEDED;
  color: #333;
  font-size: 1rem;
  line-height: 1.25rem;
}
.card-wrap .card-total {
  border: 1px solid #EDEDED !important;
}

</style>



// WEBPACK FOOTER //
// src/components/presentational/SummaryBlocks.vue?6f608bcf